enum StageViewState {
  Draft,
  Published,
  Archived,
}

export const viewStateOptions: StageViewState[] = [0, 1, 2];
export default StageViewState;
